var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSocialFb = function SvgIconSocialFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M7.526 19.167 7.5 10.834H4.167V7.501H7.5V5.417C7.5 2.324 9.415.834 12.174.834c1.322 0 2.458.098 2.789.142V4.21h-1.914c-1.5 0-1.791.713-1.791 1.76V7.5h4.367l-1.667 3.333h-2.7v8.333z"
  })));
};
export default SvgIconSocialFb;